import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ComProductCategoryModel } from 'src/app/model/com-product-category.model';

@Injectable({
  providedIn: 'root'
})
export class ComProductCategoryService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  getAll=()=> {
    return this.http.get(`${this.url}/CommissionProductCategory/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  
  save=(commission:ComProductCategoryModel)=> {
    return this.http.post(`${this.url}/CommissionProductCategory/SaveUpdate`, commission)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  saveAll=(commissions:ComProductCategoryModel[])=> { // TODO no existe endpoint
    return this.http.post(`${this.url}/CommissionProductCategory/saveAll`, commissions)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  update=(commission:ComProductCategoryModel)=> {
    return this.http.post(`${this.url}/CommissionProductCategory/SaveUpdate/${commission.commissionProductCategoryId}`, commission)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
